export default __webpack_public_path__ + "static/media/TRR-drink-salted-cream-coffee.48fa9518.png";